import { useState, type FormEvent } from "react";
import { signIn, AuthError, type Session } from "./lib/auth";

/**
 * Sign-in screen, ported from export/syndeo-mail/"Sign In.html".
 * Markup and class names are kept identical so signin.css applies verbatim.
 */
export function SignIn({ onSignedIn }: { onSignedIn: (s: Session) => void }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError(null);
    try {
      onSignedIn(await signIn(email.trim(), password));
    } catch (err) {
      setError(err instanceof AuthError ? err.message : "Could not sign in. Please try again.");
      setBusy(false);
    }
  }

  return (
    <main className="card" data-screen-label="Auth card">
      <div className="logo">
        <img src={`${import.meta.env.BASE_URL}assets/syndeo-mail-mark.svg`} alt="" />
        <b>Syndeo</b>
        <span>Mail</span>
      </div>

      <h1>Welcome back</h1>
      <p className="sub">Sign in to your mailbox.</p>

      <form onSubmit={submit}>
        <label htmlFor="inEmail">Email address</label>
        <div className="field">
          <input
            id="inEmail"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@syndeo.cloud"
            autoComplete="username"
            required
            autoFocus
          />
        </div>

        <label htmlFor="inPass">Password</label>
        <div className="field">
          <input
            id="inPass"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••••"
            autoComplete="current-password"
            required
          />
        </div>

        {error && (
          <p className="sub" role="alert" style={{ color: "#F87171", margin: "0 0 12px" }}>
            {error}
          </p>
        )}

        <div className="row">
          <span />
          <a href="#" onClick={(e) => e.preventDefault()}>
            Forgot password?
          </a>
        </div>

        <button className={`btn${busy ? " busy" : ""}`} type="submit" disabled={busy}>
          <span className="spin" />
          <span className="lbl">{busy ? "Opening your inbox…" : "Sign in"}</span>
        </button>
      </form>

      <div className="foot">
        <a href="/privacy">Privacy</a>
        <a href="/help">Help</a>
      </div>
    </main>
  );
}
